<div class="publish-tab">
  <p class="publish-tab__ready-count">{{ readyToPublishLabel }}</p>

  <p *ngIf="hasNoDestinationsSelected" class="publish-tab__warning" role="status">
    No destinations selected.
  </p>

  <div *ngIf="!hasNoDestinationsSelected" class="publish-tab__cards">
    <evrideo-clipping-studio-publish-preview-card
      *ngFor="let card of previewCards; trackBy: trackByDestinationId"
      [account]="card.account"
      [aspectRatio]="card.aspectRatio"
      [title]="card.title"
      [coverUrl]="card.coverUrl"
      [settingsLines]="card.settingsLines"
    ></evrideo-clipping-studio-publish-preview-card>
  </div>
</div>
